import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { INews, INewsInitialState } from "./newsModel";
import {
  ActiveInactiveNews,
  createNews,
  deleteNews,
  getAllActiveNews,
  getAllNews,
  getNewsByID,
  updateNews,
} from "./services/news.services";

const initialState: INewsInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  NewsID: null,
  NewsList: [],
  NewsDetail: {
    ID: null,
    NewsTitle: "",
    NewsDate: "",
    ShortDescription: "",
    LongDescription: "",
    NewsURL: "",
    MetaTitle: "",
    MetaDescription: "",
    Status: null,
    IsActive: 1,
  },
};

const newsSlice = createSlice({
  name: "news",
  initialState,
  reducers: {
    clearNewsDetails: (state) => {
      state.NewsDetail = initialState.NewsDetail;
    },
    setNewsID: (state, action) => {
      state.NewsID = action.payload;
    },
    clearNewsID: (state) => {
      state.NewsID = initialState.NewsID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllNews.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllNews.fulfilled,
      (state, action: PayloadAction<INews[]>) => {
        state.loading = false;
        state.NewsList = action.payload || [];
      }
    );
    builder.addCase(getAllNews.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.NewsList = [];
    });
    builder.addCase(createNews.pending, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(createNews.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createNews.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateNews.pending, (state) => {
      state.loading = false ;
      state.error = "";
    });
    builder.addCase(updateNews.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateNews.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteNews.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteNews.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteNews.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getNewsByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getNewsByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.NewsDetail = action.payload;
    });
    builder.addCase(getNewsByID.rejected, (state, action) => {
      state.loading = false;
      state.NewsDetail = initialState.NewsDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveNews.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveNews.fulfilled,
      (state, action: PayloadAction<INews[]>) => {
        state.loading = false;
        state.NewsList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveNews.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.NewsList = [];
    });
    builder.addCase(ActiveInactiveNews.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveNews.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveNews.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearNewsDetails, clearNewsID, setNewsID } = newsSlice.actions;
export default newsSlice.reducer;
